import { Component } from '@angular/core';

import { FormControlComponent } from '@forms/form-control/form-control.component';
import { FroalaEditorOptions } from '@forms/wysiwyg/froala-editor-options';

@Component({
  selector: 'rav-wysiwyg',
  templateUrl: './wysiwyg.component.html',
  styleUrls: ['./wysiwyg.component.scss']
})
export class WysiwygComponent extends FormControlComponent {
  froalaEditorOptions = new FroalaEditorOptions();
  constructor() {
    super();
  }
}
